import { ScheduleDate } from '../entities/ScheduleDate';

export class ScheduleValidator {
  static isFuture(date: ScheduleDate): boolean {
    return date.isAfterNow();
  }
}
